module.exports = __webpack_public_path__ + "static/media/logSpeed.6c36bb4f.svg";